<template>
  <b-modal :id="modalId" size="lg" no-close-on-backdrop hide-footer>
    <template #modal-header>
      Environment
    </template>

    <template #default>
      <validation-observer ref="proxyEnvironmentFormRef" v-slot="{ handleSubmit }">
        <b-form @submit.stop.prevent="handleSubmit(onSubmit)">

          <v-info-box
            class="mb-extra-large"
            variant="info"
            message="Make sure about env code, because after creating it you can't be able to change it">
          </v-info-box>

          <div class="d-flex mt-standard">
            <validation-provider style="flex: 1" name="code" rules="required" v-slot="validationContext">
              <b-form-group label="Code" label-for="input-proxy-environment-code">
                <b-form-input
                  id="input-proxy-environment-code"
                  v-model="proxyEnvironment.code"
                  placeholder="DEV"
                  type="text"
                  :disabled="proxyEnvironment.createdAt"
                  :state="getValidationState(validationContext)"
                ></b-form-input>
                <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>

            <validation-provider class="ml-standard" style="flex: 2" name="forwardTestToken" v-slot="validationContext">
              <b-form-group label="Forward X-Test-Token" label-for="input-proxy-forward-test-token">
                <b-form-input
                  id="input-proxy-forward-test-token"
                  v-model="proxyEnvironment.forwardTestToken"
                  placeholder="X-Test-Token (optional)"
                  type="text"
                  :state="getValidationState(validationContext)"
                ></b-form-input>
                <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </div>

          <div class="d-flex mt-standard">
            <validation-provider style="flex: 1;" name="host" rules="required" v-slot="validationContext">
              <b-form-group label="Host" label-for="input-proxy-environment-host">
                <b-form-input
                  id="input-proxy-environment-host"
                  v-model="proxyEnvironment.host"
                  placeholder="dev.host.example.pl"
                  type="text"
                  :state="getValidationState(validationContext)"
                ></b-form-input>
                <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>

            <validation-provider class="ml-standard" style="width: 200px;" name="port" rules="required" v-slot="validationContext">
              <b-form-group label="Port" label-for="input-proxy-environment-port">
                <b-form-input
                  id="input-proxy-environment-port"
                  v-model="proxyEnvironment.port"
                  placeholder="8080"
                  type="number"
                  :state="getValidationState(validationContext)"
                ></b-form-input>
                <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </div>

          <b-form-checkbox
            class="mt-large"
            v-model="proxyEnvironment.enabledSsl">
            Use SSL (https protocol)
          </b-form-checkbox>

          <div class="d-flex justify-content-end mt-large">
            <b-button @click="closeModal">
              <i class="far fa-times-circle"></i> Cancel
            </b-button>
            <b-button type="submit" variant="primary" :disabled="savingInProgress">
              <b-spinner small v-if="savingInProgress"></b-spinner>
              <span class="ml-standard" v-if="savingInProgress">Saving...</span>
              <span v-if="!savingInProgress"><i class="fas fa-save"></i> Save</span>
            </b-button>
          </div>

        </b-form>
      </validation-observer>
    </template>
  </b-modal>
</template>

<script>
  import VInfoBox from "@/components/info/InfoBox";
  import axios from 'axios';

  export default {
    components: {VInfoBox},
    props: {
      modalId: {
        type: String,
        default: 'modal-proxy-environment-editor'
      },
      onSuccess: {
        required: true,
        type: Function
      }
    },
    data() {
      return {
        proxyEnvironment: this.createDefaultEnv(),
        savingInProgress: false
      };
    },
    methods: {
      getValidationState({dirty, validated, valid = null}) {
        return dirty || validated ? valid : null;
      },
      fetchEnvData(envCode) {
        if (!envCode) {
          this.proxyEnvironment = this.createDefaultEnv();
          return
        }
        axios.get(`/api/mockConfig/proxyEnvironment/${envCode}/edit`)
          .then(response => {
            this.proxyEnvironment = response.data;
          })
          .catch(e => {
            this.$onError(e);
          })
      },
      showModal(envCode) {
        this.fetchEnvData(envCode);
        this.$bvModal.show(this.modalId)
      },
      closeModal() {
        this.$bvModal.hide(this.modalId)
      },
      onSubmit() {
        this.savingInProgress = true;
        axios.post(`/api/mockConfig/proxyEnvironment`, this.proxyEnvironment)
          .then(response => {
            this.onSuccess();
            this.closeModal()
          })
          .catch(e => {
            this.$onError(e, this.$refs.proxyEnvironmentFormRef);
          })
          .finally(() => {
            this.savingInProgress = false;
          })
      },
      createDefaultEnv() {
        return {
          code: null,
          forwardTestToken: null,
          enabledSsl: false,
          host: "10.158.118.92",
          port: 4444,
          sessionPort: 4443
        }
      }
    }
  };
</script>
